<div class="wrapper vertical">
  <app-sidenav></app-sidenav>
  <app-topbar></app-topbar>

  <!-- Nội dung thực tế (router-outlet) sẽ được chèn từ MainLayout -->
  <ng-content></ng-content>
</div>
